module.exports = __webpack_public_path__ + "static/media/req-workspace-buyer-lawyer-help1.dc92f04c.svg";